// const colours = {
// 	// black: "#000000",
// 	pink: "#F78DA7",
// 	redpink: "#F47373",
// 	magenta: "#e91e63",
// 	purple: "#9c27b0",
// 	darkpurple: "#673ab7",
// 	// navy: "#3f51b5",
// 	navy: "#02457A",

// 	cornflower: "#2196f3",
// 	gsblue: "#2a9ec5",
// 	// aqua: "#03a9f4",
// 	blue: "#97CADB",

// 	racingGreen: "#00bcd4",
// 	sage: "#6FADA2",
// 	teal: "#028A98",
// 	leafgreen: "#4caf50",
// 	yellow: "#FFEB3B",
// 	lightorange: "#FBAA68",
// 	burntorange: "#F97304",
// 	red: "#D44206",
// 	midnight: "#000000",
// 	darkGrey: "#54595f",
// 	lighterGrey: "#969799",
// 	lightGrey: "#D8D8D6",
// 	white: "#FFFFFF",
// };

// const colours1 = [
// 	"#B72025",
// 	"#D62D30",
// 	"#F04438",
// 	"#E77373",
// 	"#F09A9B",
// 	"#FACDD4",
// 	"#891951",
// 	"#C31F5C",
// 	"#EA1A65",
// 	"#F16393",
// 	"#F38FB3",
// 	"#F9BBD2",
// 	"#4C2E88",
// 	"#783294",
// 	"#913E98",
// 	"#AC6BAD",
// 	"#C894C4",
// 	"#DFBEDB",
// 	"#15499F",
// 	"#2B74B9",
// 	"#478ECC",
// 	"#70B2E2",
// 	"#96C8ED",
// 	"#BEDEF5",
// 	"#0D6064",
// 	"#1998A7",
// 	"#1BBDD4",
// 	"#58C7DA",
// 	"#88D4E2",
// 	"#B6E2ED",
// 	"#0C4E42",
// 	"#0B7A6A",
// 	"#14988B",
// 	"#48B8AC",
// 	"#7FCCC6",
// 	"#B3E0DD",
// 	"#1C6031",
// 	"#69A042",
// 	"#8AC44B",
// 	"#ADD57F",
// 	"#C4E0A6",
// 	"#DCECC8",
// 	"#F58020",
// 	"#FCC02A",
// 	"#F9ED37",
// 	"#FBF376",
// 	"#FCF6A0",
// 	"#FCF9C6",
// 	"#E65425",
// 	"#F57C1F",
// 	"#F8981D",
// 	"#FDB64E",
// 	"#FECD81",
// 	"#FFE0B1",
// 	"#3E2622",
// 	"#5E4139",
// 	"#7A5648",
// 	"#A28A80",
// 	"#BDAAA4",
// 	"#D8CDC9",
// 	"#000000",
// 	"#443E3E",
// 	"#999999",
// 	"#CCCCCC",
// 	"#EEEEEE",
// 	"#FFFFFF",
// 	"#253238",
// 	"#455B66",
// 	"#617E8C",
// 	"#90A4AF",
// 	"#B0BFC6",
// 	"#D0D9DE",
// ];

// const colours = [
// 	{ fieldIndex: 1, iValue: 0 },
// 	{ fieldIndex: 2, iValue: 11010048 },
// 	{ fieldIndex: 3, iValue: 1566765 },
// 	{ fieldIndex: 4, iValue: 10102744 },
// 	{ fieldIndex: 5, iValue: 11468799 },
// 	{ fieldIndex: 16, iValue: 16777215 },

// 	{ fieldIndex: 6, iValue: 891664 },
// 	{ fieldIndex: 7, iValue: 15199591 },
// 	{ fieldIndex: 8, iValue: 168 },
// 	{ fieldIndex: 9, iValue: 14548991 },
// 	{ fieldIndex: 10, iValue: 7410441 },
// 	{ fieldIndex: 11, iValue: 0 },
// 	{ fieldIndex: 12, iValue: 0 },
// 	{ fieldIndex: 13, iValue: 0 },
// 	{ fieldIndex: 14, iValue: 3815994 },
// 	{ fieldIndex: 15, iValue: 15461355 },
// 	{ fieldIndex: 16, iValue: 16777215 },
// 	{ fieldIndex: 17, iValue: 14540253 },
// 	{ fieldIndex: 18, iValue: 7410441 },
// 	{ fieldIndex: 19, iValue: 10066329 },
// 	{ fieldIndex: 20, iValue: 7829367 },
// 	{ fieldIndex: 21, iValue: 9004895 },
// 	{ fieldIndex: 22, iValue: 13217163 },
// 	{ fieldIndex: 23, iValue: 13289984 },
// 	{ fieldIndex: 24, iValue: 13421772 },
// 	{ fieldIndex: 25, iValue: 16777088 },
// 	{ fieldIndex: 26, iValue: 14540253 },
// 	{ fieldIndex: 27, iValue: 14548991 },
// 	{ fieldIndex: 28, iValue: 12303291 },
// 	{ fieldIndex: 29, iValue: 8947848 },
// 	{ fieldIndex: 30, iValue: 9004895 },
// 	{ fieldIndex: 31, iValue: 15658734 },
// 	{ fieldIndex: 32, iValue: 13421772 },
// 	{ fieldIndex: 33, iValue: 0 },
// 	{ fieldIndex: 34, iValue: 11010048 },
// 	{ fieldIndex: 35, iValue: 43008 },
// 	{ fieldIndex: 36, iValue: 11053056 },
// 	{ fieldIndex: 37, iValue: 168 },
// 	{ fieldIndex: 38, iValue: 11010216 },
// 	{ fieldIndex: 39, iValue: 9555952 },
// 	{ fieldIndex: 40, iValue: 11053224 },
// 	{ fieldIndex: 41, iValue: 5526612 },
// 	{ fieldIndex: 42, iValue: 15840961 },
// 	{ fieldIndex: 43, iValue: 7205219 },
// 	{ fieldIndex: 44, iValue: 16777044 },
// 	{ fieldIndex: 45, iValue: 9869037 },
// 	{ fieldIndex: 46, iValue: 15566822 },
// 	{ fieldIndex: 47, iValue: 10352620 },
// 	{ fieldIndex: 48, iValue: 16777215 },
// 	{ fieldIndex: 49, iValue: 12409065 },
// 	{ fieldIndex: 50, iValue: 11513775 },
// 	{ fieldIndex: 51, iValue: 11787554 },
// 	{ fieldIndex: 52, iValue: 5870310 },
// 	{ fieldIndex: 53, iValue: 15126777 },
// 	{ fieldIndex: 54, iValue: 3068214 },
// 	{ fieldIndex: 55, iValue: 11513775 },
// 	{ fieldIndex: 56, iValue: 2857429 },
// 	{ fieldIndex: 57, iValue: 16103593 },
// 	{ fieldIndex: 58, iValue: 4068714 },
// 	{ fieldIndex: 59, iValue: 2920915 },
// 	{ fieldIndex: 60, iValue: 3308493 },
// 	{ fieldIndex: 61, iValue: 1763000 },
// 	{ fieldIndex: 62, iValue: 10870050 },
// 	{ fieldIndex: 63, iValue: 13801958 },
// 	{ fieldIndex: 64, iValue: 0 },
// ];

// {"rows":[{"uid":"1","ref":"1","palette_ref":"1","palette_number":"1","palette_name":"Default Palette","palette_isDeleted":0,"palette_details":{"colours":[{"index":6,"colour":"#fee1e1"},{"index":7,"colour":"#eb758f"},{"index":8,"colour":"#d94c8e"},{"index":14,"colour":"#d8279a"},{"index":9,"colour":"#b32d7d"},{"index":49,"colour":"#852264"},{"index":11,"colour":"#fecac9"},{"index":12,"colour":"#FE8D8D"},{"index":13,"colour":"#ff7070"},{"index":4,"colour":"#F20733"},{"index":62,"colour":"#c40c2e"},{"index":17,"colour":"#94011d"},{"index":18,"colour":"#ffffae"},{"index":5,"colour":"#FCEA39"},{"index":19,"colour":"#ffb938"},{"index":20,"colour":"#f58122"},{"index":21,"colour":"#FE7300"},{"index":22,"colour":"#db4b16"},{"index":23,"colour":"#ccc73d"},{"index":24,"colour":"#b3b02d"},{"index":25,"colour":"#989c27"},{"index":26,"colour":"#8c8024"},{"index":27,"colour":"#7a5e37"},{"index":28,"colour":"#995F0D"},{"index":29,"colour":"#9DF892"},{"index":30,"colour":"#66FC54"},{"index":3,"colour":"#2de817"},{"index":31,"colour":"#18D401"},{"index":32,"colour":"#15B602"},{"index":33,"colour":"#0F8601"},{"index":34,"colour":"#C7FFC0"},{"index":35,"colour":"#7ccf9a"},{"index":36,"colour":"#5cb888"},{"index":37,"colour":"#3da17e"},{"index":38,"colour":"#20806c"},{"index":39,"colour":"#116062"},{"index":40,"colour":"#49c2f2"},{"index":41,"colour":"#25acf5"},{"index":42,"colour":"#1793e6"},{"index":43,"colour":"#1c75bd"},{"index":44,"colour":"#195ba6"},{"index":2,"colour":"#0000a8"},{"index":45,"colour":"#A7A7FD"},{"index":46,"colour":"#7e7ef2"},{"index":47,"colour":"#586ac4"},{"index":48,"colour":"#3553a6"},{"index":10,"colour":"#243966"},{"index":50,"colour":"#0E4ACA"},{"index":51,"colour":"#EFCAFC"},{"index":52,"colour":"#e29bfa"},{"index":53,"colour":"#ca7ef2"},{"index":54,"colour":"#a35dd9"},{"index":55,"colour":"#773bbf"},{"index":56,"colour":"#4e278c"},{"index":57,"colour":"#E4C8BF"},{"index":58,"colour":"#b58c7f"},{"index":59,"colour":"#9e7767"},{"index":60,"colour":"#875d58"},{"index":61,"colour":"#6e4250"},{"index":1,"colour":"#000000"},{"index":15,"colour":"#dedfe0"},{"index":63,"colour":"#9C9DA1"},{"index":64,"colour":"#616164"},{"index":16,"colour":"#ffffff"}]}}],"maxUid":1,"needMoreData":false}

const colours = [
	// { fieldIndex: 1, iValue: 0, colour: "#000000" },
	// { fieldIndex: 2, iValue: 11010048, colour: "#0000a8" },
	// { fieldIndex: 3, iValue: 1566765, colour: "#2de817" },
	// { fieldIndex: 4, iValue: 10102744, colour: "#d8279a" },
	// { fieldIndex: 5, iValue: 11468799, colour: "#ffffae" },
	// { fieldIndex: 16, iValue: 16777215, colour: "#ffffff" },

	{ fieldIndex: 6, iValue: 891664, colour: "#fabbaf" },

	{ fieldIndex: 7, iValue: 15199591, colour: "#eb758f" },

	{ fieldIndex: 8, iValue: 168, colour: "#d94c8e" },
	//
	{ fieldIndex: 4, iValue: 10102744, colour: "#d8279a" },
	//
	{ fieldIndex: 9, iValue: 14548991, colour: "#b32d7d" },
	{ fieldIndex: 10, iValue: 7410441, colour: "#852264" },
	{ fieldIndex: 11, iValue: 7410441, colour: "#FE8D8D" },
	{ fieldIndex: 12, iValue: 0, colour: "#ff7070" },
	{ fieldIndex: 13, iValue: 0, colour: "#f53141" },
	{ fieldIndex: 14, iValue: 3815994, colour: "#F20733" },
	{ fieldIndex: 15, iValue: 0, colour: "#c40c2e" },
	{ fieldIndex: 16, iValue: 0, colour: "#c40c2e" },
	//
	{ fieldIndex: 5, iValue: 11468799, colour: "#ffffae" },
	//
	{ fieldIndex: 17, iValue: 7829367, colour: "#FCEA39" },
	{ fieldIndex: 18, iValue: 9004895, colour: "#ffb938" },
	{ fieldIndex: 19, iValue: 16777215, colour: "#f58122" },
	{ fieldIndex: 20, iValue: 13289984, colour: "#FE7300" },
	{ fieldIndex: 21, iValue: 13421772, colour: "#db4b16" },
	{ fieldIndex: 22, iValue: 16777088, colour: "#ccc73d" },
	{ fieldIndex: 23, iValue: 14540253, colour: "#b3b02d" },
	{ fieldIndex: 24, iValue: 14548991, colour: "#989c27" },
	{ fieldIndex: 25, iValue: 12303291, colour: "#8c8024" },
	{ fieldIndex: 26, iValue: 8947848, colour: "#7a5e37" },
	{ fieldIndex: 27, iValue: 8947848, colour: "#995F0D" },
	{ fieldIndex: 28, iValue: 15658734, colour: "#9DF892" },
	{ fieldIndex: 29, iValue: 13421772, colour: "#66FC54" },
	//
	{ fieldIndex: 3, iValue: 1566765, colour: "#2de817" },
	//
	{ fieldIndex: 30, iValue: 0, colour: "#18D401" },
	{ fieldIndex: 31, iValue: 9555952, colour: "#15B602" },
	{ fieldIndex: 32, iValue: 11010048, colour: "#0F8601" },
	{ fieldIndex: 33, iValue: 43008, colour: "#C7FFC0" },
	{ fieldIndex: 34, iValue: 11053056, colour: "#7ccf9a" },
	{ fieldIndex: 35, iValue: 168, colour: "#5cb888" },
	{ fieldIndex: 36, iValue: 11010216, colour: "#3da17e" },
	{ fieldIndex: 37, iValue: 9555952, colour: "#20806c" },
	{ fieldIndex: 38, iValue: 11010048, colour: "#116062" },
	{ fieldIndex: 39, iValue: 11053224, colour: "#49c2f2" },
	{ fieldIndex: 40, iValue: 5526612, colour: "#25acf5" },
	{ fieldIndex: 41, iValue: 15840961, colour: "#1793e6" },
	{ fieldIndex: 42, iValue: 7205219, colour: "#1c75bd" },
	{ fieldIndex: 43, iValue: 16777044, colour: "#195ba6" },
	//
	{ fieldIndex: 2, iValue: 11010048, colour: "#0000a8" },
	//
	{ fieldIndex: 44, iValue: 9869037, colour: "#A7A7FD" },
	{ fieldIndex: 45, iValue: 15566822, colour: "#7e7ef2" },
	{ fieldIndex: 46, iValue: 10352620, colour: "#586ac4" },
	{ fieldIndex: 47, iValue: 16777215, colour: "#3553a6" },
	{ fieldIndex: 48, iValue: 12409065, colour: "#243966" },

	{ fieldIndex: 49, iValue: 12409065, colour: "#0E4ACA" },
	{ fieldIndex: 50, iValue: 11513775, colour: "#EFCAFC" },
	{ fieldIndex: 51, iValue: 11513775, colour: "#e29bfa" },
	{ fieldIndex: 52, iValue: 11787554, colour: "#ca7ef2" },
	{ fieldIndex: 53, iValue: 5870310, colour: "#a35dd9" },
	{ fieldIndex: 54, iValue: 15126777, colour: "#773bbf" },
	{ fieldIndex: 55, iValue: 3068214, colour: "#4e278c" },
	{ fieldIndex: 56, iValue: 11513775, colour: "#E4C8BF" },
	{ fieldIndex: 57, iValue: 11513775, colour: "#b58c7f" },
	{ fieldIndex: 58, iValue: 2857429, colour: "#9e7767" },
	{ fieldIndex: 59, iValue: 16103593, colour: "#875d58" },
	{ fieldIndex: 60, iValue: 4068714, colour: "#6e4250" },
	{ fieldIndex: 61, iValue: 2920915, colour: "#472e3e" },
	{ fieldIndex: 62, iValue: 3308493, colour: "#9C9DA1" },
	{ fieldIndex: 63, iValue: 13801958, colour: "#616164" },
	{ fieldIndex: 64, iValue: 0, colour: "#000000" },

	{ fieldIndex: 1, iValue: 0, colour: "#000000" },
	//
	{ fieldIndex: 16, iValue: 16777215, colour: "#ffffff" },
];
export default colours;

// ["#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"]

// const colours = [
// 	// { fieldIndex: 1, iValue: 0, colour: "#000000" },
// 	// { fieldIndex: 2, iValue: 11010048, colour: "#0000a8" },
// 	// { fieldIndex: 3, iValue: 1566765, colour: "#2de817" },
// 	// { fieldIndex: 4, iValue: 10102744, colour: "#d8279a" },
// 	// { fieldIndex: 5, iValue: 11468799, colour: "#ffffae" },

// 	// { fieldIndex: 16, iValue: 16777215, colour: "#ffffff" },
// 	{ fieldIndex: 6, iValue: 891664, colour: "#fabbaf" },

//
// 	{ fieldIndex: 7, iValue: 15199591, colour: "#eb758f" },
//

// 	{ fieldIndex: 8, iValue: 168, colour: "#d94c8e" },
// 	{ fieldIndex: 9, iValue: 14548991, colour: "#b32d7d" },
// 	{ fieldIndex: 4, iValue: 10102744, colour: "#d8279a" },

// 	{ fieldIndex: 10, iValue: 7410441, colour: "#fa9891" },
// 	{ fieldIndex: 11, iValue: 0, colour: "#ff7070" },
// 	{ fieldIndex: 12, iValue: 0, colour: "#f53141" },
// 	{ fieldIndex: 13, iValue: 0, colour: "#c40c2e" },
// 	{ fieldIndex: 14, iValue: 3815994, colour: "#c40c2e" },
// 	// { fieldIndex: 15, iValue: 15461355, colour: "#faa032" },
// 	// { fieldIndex: 16, iValue: 16777215, colour: "#f58122" },
// 	{ fieldIndex: 17, iValue: 14540253, colour: "#f2621f" },
// 	{ fieldIndex: 18, iValue: 7410441, colour: "#db4b16" },
// 	{ fieldIndex: 5, iValue: 11468799, colour: "#ffffae" },

// 	// { fieldIndex: 19, iValue: 10066329, colour: "#9e4c4c" },

// 	{ fieldIndex: 20, iValue: 7829367, colour: "#fad937" },
// 	{ fieldIndex: 21, iValue: 9004895, colour: "#ffb938" },
// 	{ fieldIndex: 22, iValue: 13217163, colour: "#e69b22" },
// 	{ fieldIndex: 23, iValue: 13289984, colour: "#cc8029" },
// 	{ fieldIndex: 24, iValue: 13421772, colour: "#ad6a45" },
// 	{ fieldIndex: 25, iValue: 16777088, colour: "#ccc73d" },
// 	{ fieldIndex: 26, iValue: 14540253, colour: "#b3b02d" },
// 	{ fieldIndex: 27, iValue: 14548991, colour: "#989c27" },
// 	{ fieldIndex: 28, iValue: 12303291, colour: "#8c8024" },
// 	// { fieldIndex: 29, iValue: 8947848, colour: "#7a5e37" },
// 	{ fieldIndex: 30, iValue: 9004895, colour: "#94bf30" },

// 	{ fieldIndex: 31, iValue: 15658734, colour: "#55b33b" },
// 	{ fieldIndex: 35, iValue: 43008, colour: "#a0eba8" },
// 	{ fieldIndex: 36, iValue: 11053056, colour: "#7ccf9a" },
// 	// { fieldIndex: 37, iValue: 168, colour: "#5cb888" },

// 	{ fieldIndex: 3, iValue: 1566765, colour: "#2de817" },

// 	{ fieldIndex: 32, iValue: 13421772, colour: "#179c43" },

// 	{ fieldIndex: 33, iValue: 0, colour: "#068051" },
// 	{ fieldIndex: 34, iValue: 11010048, colour: "#116061" },
// 	// { fieldIndex: 35, iValue: 43008, colour: "#a0eba8" },
// 	// { fieldIndex: 36, iValue: 11053056, colour: "#7ccf9a" },
// 	// { fieldIndex: 37, iValue: 168, colour: "#5cb888" },
// 	// { fieldIndex: 38, iValue: 11010216, colour: "#3da17e" },
// 	// { fieldIndex: 39, iValue: 9555952, colour: "#20806c" },
// 	{ fieldIndex: 40, iValue: 11053224, colour: "#49c2f2" },
// 	{ fieldIndex: 41, iValue: 5526612, colour: "#25acf5" },
// 	{ fieldIndex: 42, iValue: 15840961, colour: "#1793e6" },
// 	{ fieldIndex: 43, iValue: 7205219, colour: "#1c75bd" },
// 	{ fieldIndex: 44, iValue: 16777044, colour: "#195ba6" },
// 	{ fieldIndex: 2, iValue: 11010048, colour: "#0000a8" },

// 	{ fieldIndex: 45, iValue: 9869037, colour: "#ae88e3" },
// 	{ fieldIndex: 46, iValue: 15566822, colour: "#7e7ef2" },
// 	{ fieldIndex: 47, iValue: 10352620, colour: "#586ac4" },
// 	{ fieldIndex: 48, iValue: 16777215, colour: "#3553a6" },
// 	// { fieldIndex: 2, iValue: 11010048, colour: "#0000a8" },

// 	// { fieldIndex: 49, iValue: 12409065, colour: "#243966" },
// 	{ fieldIndex: 16, iValue: 16777215, colour: "#ffffff" },
// 	{ fieldIndex: 16, iValue: 16777215, colour: "#ffffff" },
// 	{ fieldIndex: 16, iValue: 16777215, colour: "#ffffff" },

// 	{ fieldIndex: 50, iValue: 11513775, colour: "#e29bfa" },
// 	{ fieldIndex: 51, iValue: 11787554, colour: "#ca7ef2" },
// 	{ fieldIndex: 52, iValue: 5870310, colour: "#a35dd9" },
// 	{ fieldIndex: 53, iValue: 15126777, colour: "#773bbf" },
// 	{ fieldIndex: 54, iValue: 3068214, colour: "#4e278c" },

// 	{ fieldIndex: 55, iValue: 11513775, colour: "#b58c7f" },
// 	{ fieldIndex: 56, iValue: 2857429, colour: "#9e7767" },

// 	{ fieldIndex: 57, iValue: 16103593, colour: "#875d58" },
// 	{ fieldIndex: 29, iValue: 8947848, colour: "#7a5e37" },

// 	{ fieldIndex: 58, iValue: 4068714, colour: "#6e4250" },
// 	{ fieldIndex: 59, iValue: 2920915, colour: "#472e3e" },
// 	// { fieldIndex: 16, iValue: 16777215, colour: "#ffffff" },

// 	{ fieldIndex: 60, iValue: 3308493, colour: "#a69a9c" },
// 	{ fieldIndex: 61, iValue: 1763000, colour: "#807980" },
// 	{ fieldIndex: 62, iValue: 10870050, colour: "#696570" },
// 	{ fieldIndex: 63, iValue: 13801958, colour: "#495169" },
// 	{ fieldIndex: 64, iValue: 0, colour: "#0d2140" },
// 	{ fieldIndex: 1, iValue: 0, colour: "#000000" },
// 	{ fieldIndex: 19, iValue: 10066329, colour: "#9e4c4c" },
// 	{ fieldIndex: 29, iValue: 8947848, colour: "#7a5e37" },
// 	{ fieldIndex: 15, iValue: 15461355, colour: "#faa032" },
// 	{ fieldIndex: 16, iValue: 16777215, colour: "#f58122" },
// 	{ fieldIndex: 39, iValue: 9555952, colour: "#20806c" },
// 	{ fieldIndex: 38, iValue: 11010216, colour: "#3da17e" },
// 	{ fieldIndex: 39, iValue: 9555952, colour: "#20806c" },
// 	{ fieldIndex: 37, iValue: 168, colour: "#5cb888" },
// ];
